import React from "react";
import { Box, Chip, Pagination as MuiPagination } from "@mui/material";

const Paginator = ({
  totalItems,
  page,
  rowsPerPage,
  rowsPerPageOptions = [15, 50, "All"],
  onPageChange,
  onRowsPerPageChange,
}) => {
  const totalPages =
    rowsPerPage === "All" ? 1 : Math.max(1, Math.ceil(totalItems / rowsPerPage));

  return (
    <Box
      className="d-flex align-items-center justify-content-between"
      sx={{ py: 2, px: 2, paddingTop: 0 }}
    >
      {/* Rows per page */}
      <Box className="d-flex align-items-center" sx={{ gap: 1, fontSize: 12, color: "#666" }}>
        <span>Rows Per Page</span>
        {rowsPerPageOptions.map((opt) => (
          <Chip
            key={opt}
            label={opt}
            onClick={() => onRowsPerPageChange?.(opt)}
            size="small"
            sx={{
              height: 28,
              fontSize: 12,
              borderRadius: "50%",
              cursor: "pointer",
              "& .MuiChip-label": { px: 0.85 },
              ...(rowsPerPage === opt
                ? {
                    backgroundColor: "#000",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#000", color: "#fff" },
                  }
                : { backgroundColor: "transparent", color: "#444", border: "none" }),
            }}
          />
        ))}
      </Box>

      {/* Page selector */}
      <MuiPagination
        count={totalPages}
        page={page}
        onChange={(_, v) => onPageChange?.(v)}
        size="small"
        shape="rounded"
        siblingCount={1}
        boundaryCount={1}
        sx={{
          "& .MuiPaginationItem-root": {
            fontSize: 12,
            minWidth: 28,
            height: 28,
            borderRadius: "50%",
          },
          "& .MuiPaginationItem-root.Mui-selected": {
            backgroundColor: "#000",
            color: "#fff",
          },
          "& .MuiPaginationItem-root.Mui-selected:hover": {
            backgroundColor: "#333",
          },
        }}
      />
    </Box>
  );
};

export default Paginator;
